import Quill from 'quill';
import randomId from 'shortid';

const Image = Quill.import('formats/image');

class ImageBlot extends Image {
  static blotName = "imageElement";

  static tagName = "img";
  
  static create({value, alt, shortId}) {
    const node = super.create();

    if (typeof value === 'string') {
      node.setAttribute('src', this.sanitize(value));
      node.setAttribute('alt', this.sanitize(alt));
      node.setAttribute('id', `blot-custom-id---${shortId}`);
    }

    return node;
  }

  static value(node) {
    const shortId = node.id.split('---').at(-1) !== '' ? node.id.split('---').at(-1) : randomId.generate();
    return { value: node.getAttribute('src'), alt: node.alt, shortId };
  }
}

Quill.register(ImageBlot);